import React,  { useState } from 'react';
import Typist from 'react-typist';

function HeaderTypist( { texts }) {
  const [currentTextCounter, setCurrentTextCounter] = useState(0);

  const changeTextCounter = () => {
    if (currentTextCounter >= texts.length - 1) {
      setCurrentTextCounter(0);
    } else {
      setCurrentTextCounter(currentTextCounter + 1);
    }
  };

  return (
    <Typist
      className="typist"
      typeSpeed={60}
      backSpeed={40}
      startDelay={500}
      backDelay={1000}
      key={currentTextCounter}
      onTypingDone={() => changeTextCounter()}
    >
      {texts[currentTextCounter]}
      <Typist.Delay ms={500} />
      <Typist.Backspace count={texts[currentTextCounter].length} delay={500}/>
    </Typist>
  );
}

export default HeaderTypist;
